// @flow
import React, { useState } from 'react';
import { debounce } from 'lodash';
import { Container } from 'react-bootstrap';
import { useMediaQuery } from 'react-responsive';
import { FullPage } from 'components/templates/fullPage';
import Header from 'components/templates/header';
import { OverlayModal } from 'components/templates/overlayModal';
import { RouteNames } from 'router';

type Props = {
  componentList: Array<any>,
  theme: string,
  updateTheme: () => void,
  verticals: Array<any>,
  siteSettings: any,
  type?: string,
  headerButtons?: any,
  campaignCode?: string,
  salesEmail?: string,
  showGetInTouch?: boolean,
  showShareButton?: boolean,
  showApplyNow?: boolean,
  customHeader?: boolean,
};

const PageTemplate = (props: Props) => {
  const {
    componentList,
    updateTheme,
    theme,
    siteSettings,
    verticals,
    type,
    headerButtons,
    showGetInTouch,
    textDecoration,
    toggleHeaderItem,
    closeRestaurantModal,
    headerArtistButton,
    campaignCode,
    salesEmail,
    projectInterested,
    roleName,
    showShareButton = true,
    showApplyNow,
  } = props;
  const isMobile = useMediaQuery({ query: '(max-device-width: 560px)' });
  const [showMenu, setShowMenu] = useState(false);
  const [breadcrumbs, setBreadcrumbs] = useState(
    componentList[0].breadcrumbList
  );

  const isInViewport = () => {
    let section;
    componentList.map(breadcrumb => {
      section = document.querySelector(`#${breadcrumb.sectionId}`);
      const rect = section && section.getBoundingClientRect();
      if (rect !== null) {
        if (
          rect.bottom > rect.height / 2 &&
          rect.top >= 0 &&
          !(rect.top >= rect.height / 2)
        ) {
          setBreadcrumbs(breadcrumb.breadcrumbList);
        }
      }
    });

    return breadcrumbs;
  };

  document.addEventListener(
    'scroll',
    debounce(function() {
      !isMobile && isInViewport();
    }, 300),
    {
      passive: true,
    }
  );

  return (
    <Container fluid={true} className={isMobile ? 'mobile' : ''}>
      {
        <div>
          <Header
            theme={theme}
            breadcrumbList={breadcrumbs}
            onMenuPress={value => {
              updateTheme(value);
              setShowMenu(true);
            }}
            type={type}
            roleName={roleName}
            headerButtons={headerButtons}
            showGetInTouch={showGetInTouch}
            textDecoration={textDecoration}
            toggleHeaderItem={toggleHeaderItem}
            headerArtistButton={headerArtistButton}
            closeRestaurantModal={closeRestaurantModal}
            campaignCode={campaignCode}
            salesEmail={salesEmail}
            projectInterested={projectInterested}
            showApplyNow={showApplyNow}
          />
          <FullPage
            componentList={componentList}
            theme={theme}
            updateTheme={updateTheme}
            breadcrumb={breadcrumbs}
            showShareButton={showShareButton}
          />
        </div>
      }
      {showMenu && (
        <OverlayModal
          verticals={verticals}
          siteSettings={siteSettings}
          onClosePress={() => setShowMenu(false)}
          type={'menu'}
          theme={'light-theme'}
          breadcrumbList={[
            {
              breadcrumbName: isMobile ? `Total Environment` : '',
              breadcrumbLink: isMobile ? RouteNames.landing : '',
            },
          ]}
        />
      )}
    </Container>
  );
};

export default PageTemplate;
